import { useContext } from 'react';
import { TasksContext, TasksContextData } from './context';

export function useTasks(): TasksContextData {
    const data = useContext<TasksContextData | undefined>(TasksContext);

    if (!data) {
        throw new Error(
            "TasksContextData unavailable. Are you sure you're using this in a nested component of an TasksProvider?"
        );
    }

    return data;
}
